"use client";

import dynamic from "next/dynamic";
import React from "react";

/**
 * Wrap a client-only PDF.js renderer with `next/dynamic({ssr: false})`.
 *
 * react-pdf pulls in pdfjs-dist, which evaluates `new DOMMatrix()` at module
 * load — that crashes Next.js client-component SSR prerender. Every PDF surface
 * needs the same dynamic boundary, so we centralise it here and let callers
 * pick a spinner size.
 */
export const withClientPdf = <P,>(
   load: () => Promise<{default: React.ComponentType<P>}>,
   spinner: "sm" | "lg" = "lg"
) =>
   dynamic(load, {
      ssr: false,
      loading: () => (
         <div className="w-full h-full flex items-center justify-center">
            <div
               className={
                  spinner === "lg"
                     ? "w-8 h-8 border-2 border-300 border-t-primary rounded-full animate-spin"
                     : "w-5 h-5 border-2 border-300 border-t-primary rounded-full animate-spin"
               }
            />
         </div>
      ),
   });
